var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionPoiBrand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m13 8 3 8h-2l-.375-1h-3.25L10 16H8l3-8h2Zm-1 2.667L12.875 13h-1.75L12 10.667Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.64 20.703A2.99 2.99 0 0 0 6 22.393a3.008 3.008 0 0 0 3.26-.168A3.008 3.008 0 0 0 12 24a3.009 3.009 0 0 0 2.74-1.776 3.008 3.008 0 0 0 3.26.168 3.007 3.007 0 0 0 1.485-2.907A3.008 3.008 0 0 0 22.392 18a3.007 3.007 0 0 0-.168-3.26A3.007 3.007 0 0 0 24 12a3.008 3.008 0 0 0-1.776-2.74A3.009 3.009 0 0 0 22.392 6a3.008 3.008 0 0 0-2.908-1.485A3.009 3.009 0 0 0 18 1.608a3.008 3.008 0 0 0-3.26.168A3.009 3.009 0 0 0 12 0a3.008 3.008 0 0 0-2.74 1.776A3.008 3.008 0 0 0 6 1.608a3.008 3.008 0 0 0-1.485 2.908A3.008 3.008 0 0 0 1.608 6a3.008 3.008 0 0 0 .168 3.26A3.008 3.008 0 0 0 0 12a3.007 3.007 0 0 0 1.776 2.74A3.009 3.009 0 0 0 1.608 18a2.99 2.99 0 0 0 1.69 1.36c.39.123.805.167 1.217.125-.042.413.002.827.126 1.218Zm16.767-7.789a2 2 0 0 0-.803 2.998 1 1 0 0 1-.914 1.583 2 2 0 0 0-2.195 2.195 1 1 0 0 1-1.583.914 2 2 0 0 0-2.998.803 1 1 0 0 1-1.828 0 2 2 0 0 0-2.998-.803 1 1 0 0 1-1.583-.914 2 2 0 0 0-2.195-2.195 1 1 0 0 1-.914-1.583 2 2 0 0 0-.803-2.998 1 1 0 0 1 0-1.828 2 2 0 0 0 .803-2.998 1 1 0 0 1 .914-1.583A2 2 0 0 0 6.505 4.31a1 1 0 0 1 1.583-.914 2 2 0 0 0 2.998-.803 1 1 0 0 1 1.828 0 2 2 0 0 0 2.998.803 1 1 0 0 1 1.583.914 2 2 0 0 0 2.195 2.195 1 1 0 0 1 .914 1.583 2 2 0 0 0 .803 2.998 1 1 0 0 1 0 1.828Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionPoiBrand);
export default __webpack_public_path__ + "static/media/ic_action_poi_brand.ce857ad1e4b15b17582f32b3bf9a581b.svg";
export { ForwardRef as ReactComponent };